export const raceClassesObj = Object.freeze({
  women: {
    id: 'women',
    label: 'Dam',
  },
  senior: {
    id: 'senior',
    label: 'Senior',
  },
  veteran: {
    id: 'veteran',
    label: 'Vetaran',
  },
  fwd: {
    id: 'fwd',
    label: 'Fwd',
  },
  rwd: {
    id: 'rwd',
    label: 'Rwd',
  },
  junior: {
    id: 'junior',
    label: 'Junior',
  },
});

export function checkAgeEligibility(birthYear, targetRaceClass) {
  const currentYear = new Date().getFullYear();
  const age = currentYear - birthYear;

  let participantIsEligible = false;

  switch (targetRaceClass.toLowerCase()) {
    case raceClassesObj.junior.id:
      if (age >= 15 && age <= 17) {
        participantIsEligible = true;
      }
      break;
    case raceClassesObj.women.id:
      if (age > 17) {
        participantIsEligible = true;
      }
      break;
    case raceClassesObj.fwd.id:
    case raceClassesObj.rwd.id:
    case raceClassesObj.senior.id:
      if (age > 17) {
        participantIsEligible = true;
      }
      break;
    case raceClassesObj.veteran.id:
      if (age > 49) {
        participantIsEligible = true;
      }
      break;
  }

  return participantIsEligible;
}

function checkEligibleRaceClasses(participant, targetRaceClass) {
  const participantAge = participant.participantDetails?.birthDate?.year;
  let participantIsEligible = false;

  switch (participant.raceClass) {
    case raceClassesObj.women:
      if (
        targetRaceClass === raceClassesObj.senior &&
        checkAgeEligibility(participantAge, targetRaceClass)
      ) {
        participantIsEligible = true;
      } else if (
        targetRaceClass === raceClassesObj.veteran &&
        checkAgeEligibility(participantAge, targetRaceClass)
      ) {
        participantIsEligible = true;
      } else {
        participantIsEligible = false;
      }

      break;
    case raceClassesObj.fwd:
    case raceClassesObj.rwd:
    case raceClassesObj.senior:
      if (
        targetRaceClass === raceClassesObj.women &&
        checkAgeEligibility(participantAge, targetRaceClass)
      ) {
        participantIsEligible = true;
      } else if (
        targetRaceClass === raceClassesObj.veteran &&
        checkAgeEligibility(participantAge, targetRaceClass)
      ) {
        participantIsEligible = true;
      } else {
        participantIsEligible = false;
      }

      break;
    case raceClassesObj.veteran:
      if (
        (targetRaceClass === raceClassesObj.senior ||
          targetRaceClass === raceClassesObj.women) &&
        checkAgeEligibility(participantAge, targetRaceClass)
      ) {
        participantIsEligible = true;
      } else {
        participantIsEligible = false;
      }

      break;
  }

  return participantIsEligible;
}

export default checkEligibleRaceClasses;
